<div class="content">
  <div class="sidebar bg-blue-gradient-top-right">
    <inexp-skeleton width="40%" height="1rem" />
    @for (item of menuItems; track $index) {
      <inexp-skeleton width="70%" height="0.875rem" />
    }
  </div>

  <div class="offering">
    @for (section of sections; track $index) {
      <section class="offering-section">
        <inexp-skeleton width="35%" height="2rem" />
        @for (line of lines; track $index) {
          <inexp-skeleton [width]="$last ? '60%' : '100%'" height="0.875rem" />
        }
      </section>
    }
  </div>
</div>
